import type { TOC } from '@ember/component/template-only';
import t from 'ember-intl/helpers/t';
import { and, eq, gte, not } from 'ember-truth-helpers';

interface MappedFieldHostFieldNoResultsSignature {
  Args: {
    loading?: boolean;
    searchName?: string;
    totalResults: number;
  };
  Blocks: {
    default?: [];
  };
}

export default <template>
  {{#if (and (eq @totalResults 0) @searchName (not @loading))}}
    <p class="grayDark font-hairline ml-4 m-2">
      {{#if (gte @searchName.length 3)}}
        {{t "no_results"}}
      {{else}}
        {{t "min_search"}}
      {{/if}}
    </p>
  {{/if}}
</template> satisfies TOC<MappedFieldHostFieldNoResultsSignature>;
